import { MapPin } from 'lucide-react';
import { getStoreDisplayName } from '../../utils/storeListUtils';
import type { PhysicalStoreVm } from '../viewModels/physicalStore.vm';

type StoreListItemProps = {
  store: PhysicalStoreVm;
  onSelect: (store: PhysicalStoreVm) => void;
};

export function StoreListItem({ store, onSelect }: StoreListItemProps) {
  const displayName = getStoreDisplayName(store.storeName);

  return (
    <button
      type="button"
      onClick={() => onSelect(store)}
      style={{ touchAction: 'manipulation' }}
      className="flex w-full items-start gap-3 rounded border border-gray-200 bg-[#f9f9f9] px-4 py-3 text-left transition-colors hover:bg-gray-100"
    >
      <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[#e85d4c]" aria-hidden />
      <div className="min-w-0">
        <p className="text-sm font-semibold text-gray-900">{displayName}</p>
        {store.address ? (
          <p className="mt-0.5 text-xs text-gray-500">{store.address}</p>
        ) : null}
      </div>
    </button>
  );
}
